"use client";

import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { useTheme } from "next-themes";
import React, { useCallback, useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const initialData = (theme: string) => ({
  labels: ["BTC", "ETH", "SOL"],
  datasets: [
    {
      data: [12, 19, 3],
      backgroundColor:
        theme === "light"
          ? ["rgba(0, 0, 0, 0.2)", "rgba(0, 0, 0, 0.4)", "rgba(0, 0, 0, 0.6)"]
          : [
              "rgba(255, 255, 255, 0.2)",
              "rgba(255, 255, 255, 0.4)",
              "rgba(255, 255, 255, 0.6)",
            ],

      borderWidth: 1,
    },
  ],
});

const hoverData = (theme: string) => ({
  labels: ["BTC", "ETH", "SOL"],
  datasets: [
    {
      data: [33, 33, 33],
      backgroundColor:
        theme === "light"
          ? ["rgba(0, 0, 0, 0.2)", "rgba(0, 0, 0, 0.4)", "rgba(0, 0, 0, 0.6)"]
          : [
              "rgba(255, 255, 255, 0.2)",
              "rgba(255, 255, 255, 0.4)",
              "rgba(255, 255, 255, 0.6)",
            ],

      borderWidth: 1,
    },
  ],
});

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false, // Disable the legend
    },
    tooltip: {
      enabled: false, // Disable the tooltip
    },
  },
};

const DonutChart = () => {
  const { theme } = useTheme();

  const [data, setData] = useState(initialData(theme as string));

  useEffect(() => {
    setData(initialData(theme as string));
  }, [theme]);

  const handleMouseEnter = useCallback(() => {
    setData(hoverData(theme as string));
  }, [theme]);

  const handleMouseLeave = useCallback(() => {
    setData(initialData(theme as string));
  }, [theme]);

  return (
    <div
      className="relative h-64 w-full"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChart;
